import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

import { auth } from '@/firebase.js'
import { routes } from '@/constants.js'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: routes.home,
      component: Home,
      beforeEnter: (to, from, next) => {
        if (auth.currentUser) {
          next({ name: routes.manage })
        } else {
          next()
        }
      }
    }, {
      path: '/manage',
      name: routes.manage,
      component: () => import(/* webpackChunkName: "manage" */ './views/Manage.vue'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/create',
      name: routes.create,
      component: () => import(/* webpackChunkName: "create-or-edit" */ './views/CreateOrEdit.vue'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/edit/:id',
      props: true,
      name: routes.edit,
      component: () => import(/* webpackChunkName: "create-or-edit" */ './views/CreateOrEdit.vue'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/please-connect',
      name: routes.pleaseConnect,
      component: () => import(/* webpackChunkName: "please-connect" */ './views/PleaseConnect.vue')
    }, {
      path: '*',
      name: routes.notFound,
      component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (auth.currentUser == null) {
      next({
        name: routes.pleaseConnect,
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
export { routes }
